import appConfig from "@/common/config/config";
import crypto from "@/common/utils/crypto.js";
import store from "@/store";

const install = (Vue, vm) => {
  let httpConfig = {
    baseUrl: vm.host,
    showLoading: true,
    loadingText: "加载中...",
    loadingTime: 1000,
    loadingMask: true,
    header: {
      "content-type": "application/json;charset=UTF-8",
    },
  };

  Vue.prototype.$u.http.setConfig(httpConfig);

  // 请求拦截部分，如配置，每次请求前都会执行
  Vue.prototype.$u.http.interceptor.request = (config) => {
    const token = uni.getStorageSync("token");
    // console.log(token)
    config.header.Authorization = "Bearer " + token;
    if (config.data.site_id == undefined) {
      let site = uni.getStorageSync("site");
      //config.data.site_id =  site ? site.id : 14;
      // config.data.site_id = site.id;
    }
    if (config.url == "/api/common/img_code") {
      config.responseType = "arraybuffer";
    }

    if (config.url === "/api/register/index" && store.state.sceneId) {
      config.header["scene-id"] = store.state.sceneId;
    }

    if (
      (config.url === "/api/resume/page_list" ||
        config.url === "/api/recruit_user/down_resume" ||
        config.url === "/api/recruit_user/call_phone" ||
        config.url === "/api/resume/detail") &&
      store.state.recId
    ) {
      config.header["resume-rec-id"] = store.state.recId;
    }

    let app_name = "h5";
    let pay_type = "微信";


    function getQueryVariable(variable) {
      const query = window.location.search.substring(1);
      const vars = query.split("&");
      for (let i = 0; i < vars.length; i += 1) {
        const pair = vars[i].split("=");
        if (pair[0] === variable) {
          return pair[1];
        }
      }
      return "";
    }

    const isFromAgency = window.location.href.includes("from=agency");
    if (isFromAgency) {
      const agency_id = getQueryVariable("agency_id");
      uni.setStorageSync("from", "agency");
      uni.setStorageSync("agency_id", agency_id);
    }
    config.header.from = uni.getStorageSync("from");
    config.header["agency-id"] = uni.getStorageSync("agency_id");

    let ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      // 在微信浏览器
      app_name = "微信公众号";
      pay_type = "微信";
    }







    config.data.app_name = app_name;
    config.data.pay_type = pay_type;

    return config;
    // 如果return一个false值，则会取消本次请求
    // if(config.url == '/user/rest') return false; // 取消某次请求
  };

  // 请求拦截部分，如配置，每次请求前都会执行
  Vue.prototype.$u.http.interceptor.response = (res) => {
    if (res._nt) {
      uni.setStorageSync("token", res._nt);
    } else if (res._t) {
      try {
        const newToken = crypto.decrypt(res._t);
        uni.setStorageSync("token", JSON.parse(newToken).newToken);
        console.log("解密token成功");
      } catch (e) {
        console.log("解密token失败", e.message);
      }
    }
    // const newToken = crypto.decrypt(res._t)
    if (res.url != "" && res.url != undefined) {
      if ([4001, 4002, 4003, 4004, 4005].includes(res.code)) {
        const token = uni.getStorageSync("token");
        vm.$u.api.clearToken({
          token,
        });
        uni.removeStorageSync("user");
        uni.removeStorageSync("token");
        uni.setStorageSync("redirectUrl", Vue.prototype.helper.curRoutePath());
        uni.navigateTo({
          url: res.url,
        });
      }
      if (res.code) {
        if (res.code == 3) {
          // let data = {
          //  order_id:res.data.id
          // }
          // Vue.prototype.$u.api.orderPay(data).then((ress) => {
          //  console.log(res);
          // })
        } else {
          if (res.code == 1) {
            uni.showToast({
              title: res.msg,
              duration: 2000,
              icon: "none",
              success: function () {
                uni.setStorageSync(
                  "redirectUrl",
                  Vue.prototype.helper.curRoutePath()
                );
                setTimeout(function () {
                  uni.navigateTo({ url: res.url });
                }, 2000);
              },
            });
          } else if (res.code == 2) {
            const succ_func = function (ress) {
              if (ress.confirm) {
                uni.setStorageSync(
                  "redirectUrl",
                  Vue.prototype.helper.curRoutePath()
                );
                if (res.type === 1) {
                  uni.navigateTo({
                    url: res.url,
                  });
                } else {
                  uni.switchTab({
                    url: res.url,
                  });
                }
              }
            };
            if (res.need_true) {
              uni.showModal({
                title: "提示",
                content: res.msg,
                showCancel: false,
                success: function (ress) {
                  succ_func(ress);
                },
              });
            } else {
              uni.showToast({
                title: res.msg,
                duration: 2000,
                icon: "none",
                success: function () {
                  uni.setStorageSync(
                    "redirectUrl",
                    Vue.prototype.helper.curRoutePath()
                  );
                  setTimeout(function () {
                    if (res.type == 2) {
                      uni.switchTab({ url: res.url });
                    } else {
                      uni.navigateTo({ url: res.url });
                    }
                  }, 2000);
                },
              });
            }
          }
        }
      } else {
        if (res.data.need_clear != undefined) {
          if (res.data.need_clear) {
            uni.removeStorageSync("user");
            uni.removeStorageSync("token");
          }
        }

        if (res.msg) {
          uni.showModal({
            title: "提示",
            content: res.msg,
            success: function (ress) {
              if (ress.confirm) {
                uni.setStorageSync(
                  "redirectUrl",
                  Vue.prototype.helper.curRoutePath()
                );
                uni.navigateTo({
                  url: res.url,
                });
              } else if (ress.cancel) {
                if (res.c_url == "back") {
                  uni.navigateBack();
                } else if (res.c_url) {
                  uni.navigateTo({
                    url: res.c_url,
                  });
                }
              }
            },
          });
        } else {
          if (res.url) {
            uni.setStorageSync(
              "redirectUrl",
              Vue.prototype.helper.curRoutePath()
            );
            uni.navigateTo({
              url: res.url,
            });
          }
        }
      }
      return false;
    } else {
      if (res.code == 3) {














      }
      // else if (res.code == 1101) {
      //   uni.showModal({
      //     title: "提示",
      //     confirmText: "好的",
      //     content: res.msg,
      //     confirmColor: "rgba(102, 102, 102, 1)",
      //     showCancel: false,
      //   });
      // }
      else {
        if (
          res.msg &&
          ![
            4001, 4002, 4003, 4004, 4005, 1004, 1005, 1011, 1100, 1101,
          ].includes(res.code)
        ) {
          uni.showToast({
            title: res.msg,
            duration: 2000,
            icon: "none",
          });
        }
      }
    }
    if (res.data && res.data.list) {
      res.data["data"] = res.data.list;
    }
    return res;
    // 如果return一个false值，则会取消本次请求
    // if(config.url == '/user/rest') return false; // 取消某次请求
  };
};

export default {
  install,
};
